// 特殊URL格式路由器 - 处理 ?/page?pageId=1441 格式
export class SpecialRouter {
    constructor() {
        // this.baseUrl = '/CX/ceeac/'
        this.baseUrl = '/CX/ceeac/'
        this.currentPage = 'home'
        this.currentParams = {}
        this.listeners = []
    }

    // 导航到指定页面 - 使用新的查询参数格式
    navigateTo(page, params = {}) {
        // 获取Vue Router实例
        const router = window.__VUE_ROUTER_INSTANCE__
        if (!router) {
            console.error('Vue Router instance not found')
            return
        }

        // 根据页面名称决定路由跳转，使用查询参数格式
        let query = {}

        if (page === 'home') {
            query = { p: 'index' }
        } else if (page === 'detail') {
            query = { p: 'detail' }
        } else if (page === 'about') {
            query = { p: 'person', id: params.id }
        } else if (page === 'contact') {
            query = { p: 'contact', pageId: params.pageId }
        } else if (page === 'page') {
            query = { p: 'page', pageId: params.pageId }
        } else {
            query = { p: 'index' }
        }

        router.push({
            path: '/',
            query: query
        })

        // 更新当前状态
        this.currentPage = page
        this.currentParams = params
        this.notifyListeners()
    }

    // 监听路由变化
    onRouteChange(callback) {
        this.listeners.push(callback)
    }

    notifyListeners() {
        this.listeners.forEach(callback => {
            callback(this.currentPage, this.currentParams)
        })
    }

    // 获取当前页面
    getCurrentPage() {
        return this.currentPage
    }

    // 获取当前参数
    getCurrentParams() {
        return this.currentParams
    }

    // 生成目标URL格式 - 这是关键功能
    generateUrl(page, params = {}) {
        const baseUrl = window.location.origin + this.baseUrl
        const pathPart = `?/${page}`
        const queryString = Object.keys(params).length > 0
            ? '?' + Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&')
            : ''

        return `${baseUrl}${pathPart}${queryString}`
    }
}

// 创建全局实例
export const specialRouter = new SpecialRouter()
